import { GeoLocationModal } from './subcomponents/GeoLocationModal';
import { H2, TerritoryNumberBlock } from 'src/components/_commons';
import { HTHFaceBuildingsAdd } from '../house-to-house-page/subcomponents/HTHSectionFaceBuildingsAdd';
import { ManualLocationModal } from './subcomponents/ManualLocationModal';
import { useGetConfig, useGetCurrentUser, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';
import { useNavigate } from 'react-router';
import { useState } from 'react';

export const HTHSelectorPage = () => {
    const user = useGetCurrentUser();
    //
    const [showAddBuildingFromAddressModal, setShowAddBuildingFromAddressModal] = useState(false);
    const [showAll, setShowAll] = useState(!user.hthAssignments?.length && user.isBuildingsAdmin);
    const [showGeolocationModal, setShowGeolocationModal] = useState(false);
    const [showManualLocationModal, setShowManualLocationModal] = useState(false);
    const config = useGetConfig();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const navigate = useNavigate();

    return (
        <>
        <H2 title={'CASA EN CASA'} />
        {showAddBuildingFromAddressModal &&
            <HTHFaceBuildingsAdd
                closeModal={() => setShowAddBuildingFromAddressModal(false)}
                currentFace={null}
                territoryNumber={null}
            />
        }
        {showGeolocationModal &&
            <GeoLocationModal
                closeModal={() => setShowGeolocationModal(false)}
            />
        }
        {showManualLocationModal &&
            <ManualLocationModal
                closeGeolocationModalHandler={() => setShowManualLocationModal(false)}
            />
        }
        <div className={'d-flex flex-column flex-lg-row justify-content-center align-items-center mt-4'}>
            <button className={`btn btn-general-blue ${isMobile ? '' : 'me-3'}`}
                style={{ width: '220px' }}
                onClick={() => setShowManualLocationModal(true)}
            >
                Dónde Estoy - Dirección
            </button>
            <button className={`btn btn-general-blue ${isMobile ? 'mt-2' : 'me-3'}`}
                style={{ width: '220px' }}
                onClick={() => setShowGeolocationModal(true)}
            >
                Dónde Estoy - Mapa
            </button>
            {user.isBuildingsAdmin &&
                <button className={`btn btn-general-blue ${isMobile ? 'mt-2' : 'me-3'}`}
                    style={{ width: '220px' }}
                    onClick={() => setShowAddBuildingFromAddressModal(true)}
                >
                    Agregar Edificio
                </button>
            }
            <button className={`btn btn-general-blue ${isMobile ? 'mt-2' : 'me-3'}`}
                style={{ width: '220px' }}
                onClick={() => navigate(`/selector?grupo=${user.congregation}`)}
            >
                Ir a Página Selector
            </button>
        </div>
        {user.isBuildingsAdmin &&
            !(!!user.hthAssignments?.length && user.hthAssignments.length === config.numberOfTerritories) &&
            <button className={`btn btn-general-blue d-block mx-auto my-4 ${isMobile ? 'w-75' : 'w-25'}`}
                onClick={() => setShowAll(x => !x)}
            >
                {showAll ? 'Ver solo los asignados' : 'Ver todos los territorios'}
            </button>
        }
        {!!user.hthAssignments?.length ?
            user.hthAssignments.length === config.numberOfTerritories &&
                <h3 className={`text-center ${isDarkMode ? 'text-white' : ''}`}>
                    Este usuario tiene asignados todos los territorios de Casa en Casa
                </h3>
            :
            !showAll &&
                <h3 className={`text-center ${isDarkMode ? 'text-white' : ''} mt-3`}>
                    No hay territorios de Casa en Casa asignados <br/> Hablar con el grupo de territorios
                </h3>
        }
        {(showAll || !!user.hthAssignments) &&
            <TerritoryNumberBlock
                classes={'btn-general-blue animate__animated animate__rubberBand'}
                showForecast={true}
                territories={showAll ?
                    Array.from({ length: config.numberOfTerritories }, (_, i) => i + 1)
                    :
                    [...user.hthAssignments.map(a => a.territoryNumber) ?? []]
                }
                url={'/casa-en-casa'}
            />
        }
        </>
    );
}
